export const COVAULT_URL_PASSTHRU_KEY = 'covault-url-passthru'
